var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: { title: _vm.showTitle, width: "40%", visible: _vm.dialogShow },
      on: { close: _vm.handleClose },
    },
    [
      _c(
        "el-form",
        {
          ref: "form",
          attrs: { "label-width": "100px", model: _vm.form, rules: _vm.rules },
        },
        [
          _c(
            "el-form-item",
            {
              staticClass: "templateTitle",
              attrs: { label: "模板标题", prop: "templateTitle" },
            },
            [
              _c("el-input", {
                attrs: { "show-word-limit": "", placeholder: "请输入模板标题" },
                model: {
                  value: _vm.form.templateTitle,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "templateTitle", $$v)
                  },
                  expression: "form.templateTitle",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "提示词内容", prop: "content" } },
            [
              _c("el-input", {
                attrs: {
                  id: "textarea_id",
                  rows: "15",
                  maxlength: "2000",
                  "show-word-limit": "",
                  type: "textarea",
                  resize: "none",
                  placeholder: "请输入提示词内容",
                },
                on: { input: _vm.handleInput },
                model: {
                  value: _vm.form.content,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "content", $$v)
                  },
                  expression: "form.content",
                },
              }),
            ],
            1
          ),
          _c(
            "el-row",
            { attrs: { type: "flex", justify: "end" } },
            [
              _c("el-button", { on: { click: _vm.handleClose } }, [
                _vm._v("取消"),
              ]),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.handleConfirm },
                },
                [_vm._v("确定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }